import React from 'react'
import NotFound from '../notfound'

const NotFoundDa = () => {
    return <NotFound languageCode="da" />
}

export default NotFoundDa
